import { ChildDto, DefaultFieldTypeStatusEnum, FamilyDto, FieldValueInterface } from '@families-link/shared';
import dayjs from 'dayjs';
import { DefaultFormFieldsInterface } from './getDefaultFormFields.util';

export const transformValuesObject = (
	values: any,
	typeInForm: string,
	defaultFormFields: DefaultFormFieldsInterface
) => {
	const transformedValues = Object.keys(values).reduce(
		(submitObject: { [k: string]: any }, key) => {
			if (
				typeInForm === DefaultFieldTypeStatusEnum.Appointment &&
				(key === `day` || key === 'time' || key === 'appointmentDuration')
			) {
				const startDate =
					values[`day`] && values['time']
						? dayjs(values[`day`])
								.hour(values['time'].hour())
								.minute(values['time'].minute())
								.second(values['time'].second())
						: null;
				const endDate = startDate ? startDate.add(values['appointmentDuration'], 'millisecond') : null;
				submitObject['duration'] = {
					startDate: startDate ? startDate.toDate() : null,
					endDate: endDate?.toDate(),
				};
			} else if (typeInForm === DefaultFieldTypeStatusEnum.Appointment && key === `duration`) {
				// skip it
			} else if (typeInForm === DefaultFieldTypeStatusEnum.Project && key === `duration`) {
				submitObject['duration'] = {
					startDate: values[key][0] ? dayjs(new Date(values[key][0])).hour(0).minute(0).second(0).toDate() : null,
					endDate: values[key][1] ? dayjs(new Date(values[key][1])).hour(23).minute(59).second(59).toDate() : null,
				};
			} else if (key.startsWith('field_')) {
				if (key !== `field_${defaultFormFields.duration?._id}`) {
					const existField = submitObject['customFieldsValues'].find(
						(el: FieldValueInterface) => el.fieldId.toString() === key.replace('field_', '')
					);

					if (existField) {
						existField.value = values[key];
					} else {
						const fieldId = key.replace('field_', '');
						submitObject['customFieldsValues'].push({
							fieldId,
							value: values[key],
						});
					}
				}
			} else if (key === 'provider') {
				submitObject['providerId'] = values[key]?._id;
				submitObject['provider'] = values[key];
			} else if (key === 'children') {
				submitObject['childIds'] =
					values[key]?.length === 0 ? undefined : values[key]?.map((item: ChildDto) => item?._id);
				submitObject['children'] = values[key];
			} else {
				submitObject[key] = values[key];
			}

			return submitObject;
		},
		{ customFieldsValues: [] }
	);

	return transformedValues;
};
